import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-delete-component',
  templateUrl: './delete-component.component.html',
  styleUrls: ['./delete-component.component.scss']
})
export class DeleteComponentComponent implements OnInit {
  isPermanent: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DeleteComponentComponent>
  ) {


  }

  ngOnInit(): void {
  }
  setAll(checked) {
    this.isPermanent = checked;
  }
  onConfirm() {
    this.dialogRef.close({ isPermanent: this.isPermanent })
  }
}
